import axios from 'axios';

const urlParams = new URLSearchParams(window.location.search);

export let instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});
instance.interceptors.request.use(function (config) {
    const token = urlParams.get('t') || localStorage.getItem('token');
    if (token) {
        localStorage.setItem('token', token);
    } else {
        window.location.href = 'https://eyesee-hubs.com/login';
    }
    config.headers.Authorization = `Bearer ${token}`;

    return config;
});
